import { useMutation } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import { OptimizationQuestionsResponseDto } from "@reactive-resume/dto";

export const generateOptimizationQuestions = async (data: { id: string }) => {
  const response = await axios.post<OptimizationQuestionsResponseDto>(
    `/resume-optimizer/questions/${data.id}`,
  );
  return response.data;
};

export const useGenerateOptimizationQuestions = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: generateQuestionsFn,
  } = useMutation({
    mutationFn: generateOptimizationQuestions,
  });

  return { generateQuestions: generateQuestionsFn, loading, error };
}; 